module.exports = __webpack_public_path__ + "media/images/LandRegistry_Logo-ab4ee935.png";